import * as React from "react";

import { Resources, useResource } from "Translations/Resources";

import { GoogleButton } from "Components/Auth/Google/GoogleButton";
import LoginImage from "Assets/Images/login-image.png";
import { UnauthenticatedLayout } from "Components/Layout/UnauthenticatedLayout";

export const LoginPage: React.FunctionComponent = _ => {
  const { t } = useResource();

  return (
    <UnauthenticatedLayout
      title={t(Resources.Login.FormTitle)}
      subTitle={t(Resources.Login.FormSubTitle)}
      image={<img src={LoginImage} alt={""} />}
      btn={<GoogleButton />}
      isLoginPage
    ></UnauthenticatedLayout>
  );
};
